<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
    <div fxFlex="100" fxLayout="column">
        <div fxFlex="100" fxLayout="row">
            <div fxFlex="100" class="background">
                <div class="container main">


                    <div fxLayout="row">

                        <div (click)="back()" fxLayoutAlign="center center" class="back pointer">
                            <mat-icon style="color: black;">keyboard_backspace</mat-icon>
                        </div>

                        <div fxFlex="2">

                        </div>

                        <h1 style="color: white;">{{name}}</h1>
                    </div>
                    <div fxLayout="row">
                        <p [innerHTML]="CourceDescription"
                            style="font-size: 20px; font-weight: bolder; color: white; max-width: 75ch; word-wrap: break-word;">
                        </p>
                        <br>
                        <span style="font-size: larger; color: coral;">
                        </span>
                    </div>

                    <div fxLayout="row" fxLayout.xs="column">
                        <div *ngIf="LastUpdated?.length>0" fxLayout="row" fxLayoutAlign="start center"
                            class="spec-item-new">
                            <div class="spec-logo2" fxFlex fxFlex.xs="15">
                                <mat-icon>new_releases</mat-icon>
                            </div>
                            <div class="spec-value" style="max-width: 75ch; word-wrap: break-word;">{{LastUpdated}}
                            </div>
                        </div>

                        <div *ngIf="Language?.length>0" fxLayout="row" fxLayoutAlign="start center"
                            class="spec-item-new">
                            <div class="spec-logo2" fxFlex fxFlex.xs="15">
                                <mat-icon>language</mat-icon>
                            </div>
                            <div class="spec-value" style="max-width: 75ch; word-wrap: break-word;">{{Language}}</div>
                        </div>
                    </div>



                </div>

            </div>
        </div>

        <div class="container" fxLayout="row" ffxLayoutAlign="start start" fxLayout.xs="column"  fxLayoutGap="10px" >
            <div fxFlex="60" fxFlex.xs="100">
                <div *ngIf="shortDescription!=null" style="margin-top: 10px;">
                    <div class="spec-table">
                        <div>
                            <h2>What you'll learn</h2>
                        </div>
                        <div>
                            <div *ngFor="let item of shortDescription.split(',,')">
                                <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                    <mat-icon fxFlex="none" class="maticoncss"
                                        style="margin-right: 8px;">check_circle</mat-icon>
                                    <span class="spec-value" [innerHTML]="item.trim()"></span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div *ngIf="specificationList!=null" style="margin-top: 10px;">
                    <div>
                        <div>
                            <h2>This course includes</h2>
                        </div>
                        <div fxLayout="row wrap">
                            <div *ngFor="let item of specificationList; let i = index" fxFlex="50">
                                <div fxLayout="row" fxLayoutAlign="start center" class="spec-item">
                                    <div *ngIf="item.specificationType == '0'" fxFlex="20">
                                        <img class="spec-logo2" [src]="serverPathSpecification + item.iconImages"
                                            [alt]="item.iconImages">
                                    </div>
                                    <div *ngIf="item.specificationType == '1'" class="spec-logo2" fxFlex="20">
                                        <mat-icon>check_circle_outline</mat-icon>
                                    </div>
                                    <div class="spec-value" fxFlex="60">{{ item.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div style="margin-top: 10px;">

                    <div fxLayout="row">
                        <h2>
                            <b>
                                Course content
                            </b>
                        </h2>
                    </div>

                    <!-- <div fxLayout="row">
                        sections • 729 lectures • 74h 12m total length
                    </div> -->

                    <div *ngFor="let section of courseText; let i = index">
                        <div fxLayout="column">
                            <div fxLayout="row" class="cat pointer" fxFlex="50" fxLayoutGap="10px" >
                                <div fxFlex="5" fxLayoutAlign="center center"  (click)="toggleAccordion(i, $event)"
                                    style="cursor: pointer;">
                                    <button *ngIf="accordionOpenIndex !== i" mat-icon-button>
                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                    </button>
                                    <button *ngIf="accordionOpenIndex === i" (click)="closeAccordion($event)"
                                        mat-icon-button>
                                        <mat-icon>keyboard_arrow_up</mat-icon>
                                    </button>
                                </div>
                                <div (click)="toggleAccordion(i, $event)" fxFlex fxFlex.xs="100"
                                    fxLayoutAlign="center center">
                                    <p style="font-weight: bolder;">{{section.title}}</p>
                                </div>
                                <div (click)="toggleAccordion(i, $event)" fxFlex="10" fxFlex.xs="50"
                                    fxLayoutAlign="center center">
                                    <span> {{ section.courseItem.length }} lecture{{ section.courseItem.length !== 1 ?
                                        's' : ''
                                        }}</span>
                                </div>
                                <div (click)="toggleAccordion(i, $event)" fxFlex="10" fxFlex.xs="50" class="timeming"
                                    fxLayoutAlign="center center">
                                    <!-- <span>1 mins</span> -->
                                </div>
                            </div>

                            <div fxLayout="column" *ngIf="accordionOpenIndex === i"
                                style="border: 1px solid lightgray; padding: 2px;">
                                <div *ngFor="let subsection of section.courseItem; let j = index" fxLayout="column"
                                    class="subsection-container" style="border: 1px solid lightgray;">
                                    <div fxLayout="row" fxLayoutAlign="start center" class="subsection-header">
                                        <div fxFlex="5" fxFlex.xs="100">
                                            <mat-icon>insert_drive_file</mat-icon>
                                        </div>
                                        <div (click)="subtoggleAccordion(i, j)" fxFlex="40" fxFlex.xs="100"
                                            class="subsection-content pointer">
                                            <span>{{subsection.title}}</span>
                                        </div>
                                        <div fxFlex="35" fxFlex.xs="100" fxLayoutAlign="end center">
                                            <span (click)="subtoggleAccordion(i, j)" style="cursor: pointer;">
                                                <button *ngIf="subaccordionOpenIndex[i] !== j" mat-icon-button>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </button>
                                                <button *ngIf="subaccordionOpenIndex[i] === j" mat-icon-button>
                                                    <mat-icon>keyboard_arrow_up</mat-icon>
                                                </button>
                                            </span>
                                        </div>
                                        <div fxFlex="15" fxLayoutAlign="end center">
                                            <span class="duration">{{subsection.customField2}}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="subaccordionOpenIndex[i] === j" class="subsection-details">
                                        <div [ngClass]="{ 'overlayLayout': subsection.customField3 == 1 || subsection.customField3 == null, 'asas': subsection.customField3 != 1 }"
                                            fxLayout="row">
                                            <div fxFlex="5"></div>
                                            <div fxFlex="50">
                                                <span>{{subsection.customField1}}</span>
                                            </div>
                                            <div fxFlex fxLayoutAlign="end center">
                                                <div *ngIf="!subsection.value.includes('pdf') && subsection.type!=9">
                                                    <a [ngClass]="{ overlayProduct: subsection.freePreview == 0 }"
                                                        (click)="subsection.freePreview == 0 ? RestrictionDialog() : ViewVideo(subsection)"
                                                        mat-flat-button class="viewbtn">
                                                        Preview
                                                    </a>

                                                </div>
                                                <div [ngClass]="{ overlayProduct: subsection.freePreview == 0 }"
                                                    *ngIf="subsection.value.includes('pdf') && subsection.type!=9">
                                                    <button class="pdfbtn" mat-button mat-stroked-button
                                                        (click)="subsection.freePreview == 0 ? RestrictionDialog() : downloadPdf(subsection.value)">Download
                                                        Pdf</button>
                                                </div>

                                                <div [ngClass]="{ overlayProduct: subsection.freePreview == 0 }"
                                                    *ngIf="subsection.type==9">

                                                    <!-- <button style="color: white;" class="primary"
                                                        (click)="subsection.freePreview == 0 ? RestrictionDialog() : NavigateQuiz(subsection.value)"
                                                        mat-stroked-button>
                                                        Try It</button> -->
                                                </div>
                                            </div>
                                            <div fxFlex="10"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 10px;">
                    <div>
                        <div>
                            <h2>Description</h2>
                        </div>

                        <div>
                            <p [innerHTML]="description">
                            </p>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 10px;">
                    <div>
                        <div>
                            <div class="instructor-container">
                                <div class="instructor-header" fxLayout="column" fxLayoutAlign="start">
                                    <h1>Instructor</h1>
                                    <span  class="instructor-name">{{LectureDetails?.company}}</span>
                                    <p>{{LectureDetails?.name}}</p>
                                </div>

                                <div class="instructor-info" fxLayout="row" fxLayoutAlign="start center">
                                    <div class="instructor-image">
                                        <img [src]="LecturerServerPath + LectureDetails?.logo"
                                            [alt]="LectureDetails?.logo" />
                                    </div>
                                    <div class="instructor-details" fxLayout="column" fxLayoutGap="5px">
                                        <div>
                                            <mat-icon>play_circle_filled</mat-icon>
                                            <span>{{LectureDetails?.supplierWebsite}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="LectureDetails?.vatNo.length>0" class="instructor-bio">
                                    <div class="dBQOmu" [class.expanded]="isExpanded">{{LectureDetails?.vatNo}}</div>
                                    <div class="erefAN" (click)="toggleContent()"
                                        style="color: #1a0dab; cursor: pointer; display: flex; align-items: center;">
                                        <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        <span>{{ isExpanded ? ' Show Less' : ' Show More' }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            <div fxFlex="40" fxFlex.xs="100" class="bg-color">
                <div class="prod" fxLayout="row" fxLayout.sm="column" class="pd padding-10" fxLayoutGap="2px">
                    <div fxFlex="100" class="product-details1 border" ngClass.gt-md="padding-20">

                        <div fxLayout="column">

                            <div fxFlex="100" fxLayout="row">
                            </div>

                        </div>

                        <div fxFlex="100" fxLayout="row">
                            <div *ngIf="data.disablePriceInDetailPage==0">
                                <calsoft-price [specialPrice]="specialPrice" [data]="data" [product]="product"
                                    [price]="price" [discountPercentage]="discountPercentage"
                                    [units]="units"></calsoft-price>
                            </div>
                        </div>

                        <div fxLayout="row" fxFlex="100">
                            <div fxFlex="100" *ngIf="data.disableCartInDetailPage==0 && product.type!='Subscription'">
                                <div *ngIf="isInStock==1 ">
                                    <calsoft-controls [data]="data" [coversionTrackingIdGa]="coversionTrackingIdGa"
                                        *ngIf="(qty>0 && isInStock==1)||(manageStock==0); else elseBlock"  [productCustomOption]="productCustomOption"
                                        [productOption]="salesFlatQuoteItemOption" [product]="configProductSelected"
                                        [configproduct]="product" [type]="'addtocart'" [buttonArray]="buttonArray"
                                        [configproduct]="product"></calsoft-controls>
                                </div>
                            </div>
                        </div>

                        <div fxLayout="row" *ngIf="isInStock==0">
                            <div fxLayout="column" fxLayoutGap="5px">
                                <h1>Not Available</h1>
                                <span>Currently Course Not Available </span>
                            </div>
                        </div>

                        <ng-template #elseBlock>
                            <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
                                <div fxLayout="row">
                                    <h2>Not Available</h2>
                                </div>
                                <div fxLayout="row" class="padding-3" fxFlex>
                                    <span>Currently Course Not Available </span>
                                </div>
                                <div fxLayout="row" fxFlex>
                                    <button mat-raised-button (click)="initOutStockFunction()" color="warn"
                                        class="btn btn-small btn-info padding-10" type="button" data-bind="click: ok">
                                        Notify Me
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div fxLayout="column"  class="subscriptionPrice">

                    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">

                        <div *ngIf="product.type=='Variants Subscription'&&configurationDropDownList.size>0" class="pt padding-10" fxFlex="100" >
                            <span fxFlex="100" style="background-color: gray; padding: 10px; color: white;">
                                Subscription
                            </span>
                        </div>
                       

                    </div>

                    <div  *ngIf="configurationDropDownList.size>0"
                      >

                      <div class="pd padding-10" fxLayout="row">

                        <div fxFlex="100" class="product-details1 pt border">

                        <ng-container style="margin-left: 5px;" *ngIf="!showNewConfig; else newconfig">
                            <div fxLayout="row" style="margin-left: 5px;">
                              <ng-container *ngIf="configattributeType==1;">
                                <div [style.padding-top]="configurationDropDownList.size==0 ? '0px' : '10px'" fxLayout="row"
                                  *ngFor="let item of configurationDropDownList | keyvalue">
                                  <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                      {{item.key.replace('_', ' ') }}
                                    </mat-label>
                                    <mat-select (selectionChange)="getConfigProductId($event.value,i)" [disableOptionCentering]="true"
                                      [formControl]="dropDownValue">
                                      <mat-option [value]="object" *ngFor="let object of item.value;let i=index ">
                                        {{object |splitbyHash}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                              </ng-container>
                  
                  
                              <ng-container *ngIf="configattributeType==2;">
                  
                                <!-- <span class="mtb10">
                    
                                      <div class="size mtb10" fxLayoutGap="5px" fxLayout="column"
                                          *ngFor="let item of configurationDropDownList | keyvalue">
                                          <div fxFlex fxLayout="row">
                                              <span> {{item.key}}:</span>
                                          </div>
                    
                                          <div fxFlex fxLayout="row">
                                              <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                                  <div fxFlex="18" *ngFor="let object of item.value;let i=index;"
                                                      class="imagesProduct" [class.highlightedImage]="firstIndex ==i"
                                                      [class.highlightedImage1]="firstIndex !=i" fxLayout="column"
                                                      fxLayoutAlign="center center">
                                                      <div class="imagesPro padding-3">
                                                          <a (click)="getConfigProductId(object,i)">
                                                              <img [alt]="name" class="imgH"
                                                                  [src]="getImageproductIdOld(object)"
                                                                  onerror="this.src='assets/images/products/noImage/no-image.png';"
                                                                  alt="">
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </span> -->
                  
                                <span class="mtb10">
                  
                                  <div class="size,mtb10" fxLayoutGap="5px" *ngFor="let object  of configurationDropDownList | keyvalue">
                                    <span>{{object.key.replace('_', ' ') }}:</span>
                                    <div fxFlex fxLayout="row">
                                      <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                        <div fxflex="33.33" *ngFor="let size of object.value;let i=index;" class="imagesProduct"
                                          [class.highlightedImage]="i == firstIndex" fxLayout="column" fxLayoutAlign="center center">
                                          <div class="imagesPro padding-3">
                                            <a (click)="getConfigProductId(size,i)">
                  
                  
                                              <img [alt]="name" class="imgH" [src]="getImageproductIdOld(size)"
                                                onerror="this.src='assets/images/products/noImage/no-image.png';">
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                  
                                  </div>
                                </span>
                  
                  
                  
                  
                              </ng-container>
                  
                              <ng-container *ngIf="configattributeType==4;">
                                <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">
                  
                                  <div class="size,mtb10" fxLayoutGap="5px">
                                    <span class="fw-500"> {{item.key.replace('_', ' ') }}:</span>
                                    <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
                                      (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;"
                                      [style.background]="object |splitbyHash">&nbsp;</button>
                                  </div>
                                </span>
                  
                              </ng-container>
                  
                              <ng-container *ngIf="configattributeType==3;">
                                <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">
                  
                                  <div class="size mtb10" fxLayoutGap="5px">
                                    <span class="fw-500 mtb10"> {{item.key.replace('_', ' ') }}:&nbsp;</span>
                                    <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
                                      (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;">
                                      {{object |splitbyHash}}
                                    </button>
                                  </div>
                                </span>
                  
                              </ng-container>
                  
                            </div>
                          </ng-container>
                  
                  
                          <ng-template #newconfig>
                            <div fxLayout="row" style="margin-left: 5px;" fxLayoutGap="5px">
                              <ng-container>
                  
                                <ng-container *ngIf="configurationDropDownList[0].configAttributeType==1;">
                  
                  
                                  <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                      {{configurationDropDownList[0].key}}
                                    </mat-label>
                  
                  
                                    <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                                      <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                                        [value]="item.value" *ngFor="let item of configurationDropDownList;let i=index;">
                                        {{item.value}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                  
                                </ng-container>
                  
                  
                                <ng-container *ngIf="configurationDropDownList[0].configAttributeType==4;">
                  
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                                      <button [class.highlightedImage]="i == firstIndex" fxLayoutGap="5px" mat-raised-button
                                        (click)="getConfigProductIdButton(i,'firstIndex')"
                                        *ngFor="let size of configurationDropDownList;let i=index;"
                                        [style.background]="size.value">&nbsp;</button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                                <ng-container *ngIf="configurationDropDownList[0].configAttributeType==5;">
                  
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                                      <button fxLayoutGap="5px" mat-mini-fab (click)="getConfigProductIdButton(i,'firstIndex')"
                                        *ngFor="let size of configurationDropDownList;let i=index;" [style.background]="size.value">
                                        <mat-icon *ngIf="i == firstIndex">done</mat-icon>
                                      </button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                                <ng-container *ngIf="configurationDropDownList[0].configAttributeType==2;">
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span>{{configurationDropDownList[0].key}}:</span>
                                      <div fxFlex fxLayout="row">
                                        <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                          <div fxflex="33.33" *ngFor="let size of configurationDropDownList;let i=index;"
                                            class="imagesProduct" [class.highlightedImage]="i == firstIndex" fxLayout="column"
                                            fxLayoutAlign="center center">
                                            <div class="imagesPro padding-3">
                                              <a (click)="getConfigProductIdButton(i,'firstIndex')">
                  
                  
                                                <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                                                  onerror="this.src='assets/images/products/noImage/no-image.png';" [alt]="name">
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                  
                  
                                <ng-container *ngIf="configurationDropDownList[0].configAttributeType==3;">
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span>{{configurationDropDownList[0].key}}:</span>
                  
                                      <button fxLayoutGap="5px" mat-raised-button (click)="getConfigProductIdButton(i,'firstIndex')"
                                        [class.highlightedImage]="firstIndex ==i "
                                        *ngFor="let size of configurationDropDownList;let i=index;">
                  
                                        {{size.value}}</button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                  
                              </ng-container>
                            </div>
                            <div fxLayout="row" style="margin-left: 5px;">
                              <ng-container fxLayout="row">
                                <ng-container *ngIf="configurationDropDownList[0]
                                    ['recursuive'][0].configAttributeType==1;">
                  
                                  <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>
                                      {{configurationDropDownList[0]
                                      ['recursuive'][0].key}}
                                    </mat-label>
                                    <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
                                      .recursuive[secondIndex].value" [disableOptionCentering]="true">
                                      <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                                        [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
                               ['recursuive'];let j=index;">
                                        {{item1.value}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </ng-container>
                  
                  
                                <ng-container *ngIf="configurationDropDownList[0]
                                   ['recursuive'][0].configAttributeType==2;">
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span>{{configurationDropDownList[0]
                                        ['recursuive'][0].key}}:</span>
                                      <div fxFlex fxLayout="row">
                                        <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                                          <div fxflex="33.33" *ngFor="let size of  configurationDropDownList[firstIndex]
                                              ['recursuive'];let j=index;" class="imagesProduct"
                                            [class.highlightedImage]="secondIndex ==j" fxLayout="column" fxLayoutAlign="center center">
                                            <div class="imagesPro padding-3">
                  
                                              <a (click)="getConfigProductIdButton(j,'secondIndex')">
                  
                                                <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                                                  onerror="this.src='assets/images/products/noImage/no-image.png';">
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                                <ng-container *ngIf="configurationDropDownList[0]
                                  ['recursuive'][0].configAttributeType==4;">
                  
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span class="fw-500"> {{configurationDropDownList[0]
                                        ['recursuive'][0].key}}:</span>
                                      <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                                        (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
                                      ['recursuive'];let j=index; " [style.background]="size.value">&nbsp;</button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                                <ng-container *ngIf="configurationDropDownList[0]
                                  ['recursuive'][0].configAttributeType==5;">
                  
                                  <span class="mtb10">
                  
                                    <div fxLayoutGap="5px">
                                      <span> {{configurationDropDownList[0]
                                        ['recursuive'][0].key}}:</span>
                                      <button [class.highlightedImage]="secondIndex ==j" mat-mini-fab
                                        (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
                                      ['recursuive'];let j=index; " [style.background]="size.value">
                                        &nbsp;</button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                  
                  
                  
                                <ng-container *ngIf="configurationDropDownList[0]
                                  ['recursuive'][0].configAttributeType==3;">
                                  <span class="mtb10">
                  
                                    <div class="size,mtb10" fxLayoutGap="5px">
                                      <span class="fw-500"> {{configurationDropDownList[0]
                                        ['recursuive'][0].key}}:</span>
                                      <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                                        (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
                                      ['recursuive'];let j=index;">{{size.value}}</button>
                                    </div>
                                  </span>
                  
                                </ng-container>
                              </ng-container>
                            </div>
                  
                          </ng-template>

                          </div>

                    </div>

                    </div>
                  

                </div>
            </div>
        </div>


    </div>



    <div class="component-margin">
        <span id="objective" class="in-page-offset-anchor"></span>
        <!-- 
        <div data-purpose="course-curriculum">
          <h2 class="ud-heading-xl curriculum--curriculum-header--vxTrz" data-purpose="curriculum-header">Course content</h2>
          <div class="curriculum--curriculum-sub-header--QqY6d">
            <div class="ud-text-sm" data-purpose="curriculum-stats">
              <span> {{courseText.length }} sections {{ courseText.courseItem.length !== 1 ? 'lectures' : '' }}</span> 
              <a style="font-weight: bold; color: blue;" fxFlex="29" fxLayoutAlign="end center" class="heading" href="">Expand all sections</a>
            </div>
          </div>
        </div>
      -->
    </div>


</div>

<ng-template #video>

    <div class="video-modal">
        <h2 style="margin-left: 38px;margin-top: 10px;">{{videocontent.title}}</h2>
        <div style="width: 90%; margin-left: auto; margin-right: auto;">
            <div *ngIf="type==1">
 
                <video #videoPlayer oncanplay="this.play()" disablePictureInPicture onloadedmetadata="this.muted = true" style="width: 100%;"
                    muted controls (ended)="onVideoEnded()" controlsList="nodownload">
                    <source [src]="serverPath + currentVideoUrl">
                </video>
                <div>
                    <!-- <div *ngFor="let link of videolist; let i = index" fxLayout="row"
                        (click)="changeVideo(link.value, link.title)"
                        style="background-color: black;cursor: pointer;border: 1px solid white; overflow-y: auto;">
                        <div [ngClass]="{'active-video': link.title === activeIndex}" fxLayout="row"
                            style="width: 100%;padding: 10px;">
                            <div fxFlex="15" fxLayoutAlign="center center"></div>
                            <div fxFlex="70" fxLayoutAlign="center center">
                                <h4 style="color: white;">{{link.title}}</h4>
                            </div>
                            <div fxFlex="15" fxLayoutAlign="center center">
                                <h4 style="color: white;">{{videocontent.customField1}}</h4>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div *ngIf="type==3">
                <img [src]="serverPath1 + videocontent.value" style="width: 100%;" />
            </div>
            <div *ngIf="type==8" fxFlex="100" fxLayoutAlign="center center">
                <audio oncanplay="this.play()" onloadedmetadata="this.muted = true" style="width: 100%;" muted controls
                    (ended)="onVideoEnded()" controlsList="nodownload" controls>
                    <source [src]="serverPath2 + currentVideoUrl">
                </audio>
            </div>
            <div *ngIf="type==7">
                <p [innerHTML]="videocontent.value"></p>
            </div>

            <div *ngIf="type==6">
                <iframe style="width: 100%;" [style.height]="productImageHeight"
                    [src]="youtubeUrl+ currentVideoUrl + '?autoplay=1' | safe: 'resourceUrl'" frameborder="0"
                    allow="autoplay"></iframe>
            </div>
            <div *ngIf="type==2" fxLayoutAlign="center center">
                <button class="pdfbtn" mat-button mat-stroked-button (click)="downloadPdf(currentVideoUrl)">Download
                    Pdf</button>
            </div>
        </div>
        <button type="button" class="close" (click)="closeModal()"><span><mat-icon>close</mat-icon></span></button>
    </div>
</ng-template>